import React from "react";
import Header from "../Header/Header";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../Footer/Footer";
import "../TermsCondition/TermsCondition.css";
import image1 from "../assets/image/Group 6.png";
import image2 from "../assets/image/Group 7.png";
import image3 from "../assets/image/Group 1 (1).png";
import image4 from "../assets/image/Group 5 (1).png";
import image5 from "../assets/image/Group 4 (1).png";
import image6 from "../assets/image/Group 3 (1).png";
import image7 from "../assets/image/Group 2 (1).png";

export default function About() {
  return (
    <div>
      <Header />
      <Container style={{ fontFamily: "Caros" }} className="containt">
        <div className="TermsCondition">
          <h3 className="border-bottom pb-2 text-center mb-3">How We Work</h3>

          <div className="row d-flex align-items-center">
            <div className="col-lg-7">
              <div className="col-lg-12">
                <div>
                  <h5
                    className="mainClass"
                    style={{ color: "rgba(173, 77, 255, 1)" }}
                  >
                    <b>Choose Your Service</b>
                  </h5>
                  <p className="mt-3">
                    pujaguru provides a wide array of options tailored to meet
                    your requirements.
                  </p>
                  <p className="mt-3">
                    From engaging in conversations or chats with a specialist,
                    obtaining detailed reports, to experiencing online or
                    in-person rituals, all aimed at fostering peace and
                    prosperity in your life.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 images">
              <div className="image1">
                <img className="img-fluid" src={image1} alt="" />
              </div>
            </div>
          </div>

          <div
            style={{ backgroundColor: "rgba(240, 245, 255, 1)" }}
            className="row mt-2 d-flex align-items-center flex-wrap-reverse"
          >
            <div className="col-lg-5 images">
              <div className="image1">
                <img className="img-fluid" src={image2} alt="" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="col-lg-12">
                <div className="p-3">
                  <h5
                    className="mainClass"
                    style={{ color: "rgba(173, 77, 255, 1)" }}
                  >
                    <b>Choose Your Specialist</b>
                  </h5>
                  <p className="mt-3">
                    After selecting the service that aligns with your
                    requirements, you have the opportunity to select your
                    specialist. <br />
                    <br />
                    Browse through profiles of various specialists available on
                    the platform and opt for the one who best fits your criteria
                    or resonates with you. <br />
                    <br />
                    Rest assured, all specialists on pujaguru are thoroughly
                    verified, highly proficient, and accomplished in their
                    respective fields.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row d-flex align-items-center mt-3">
            <div className="col-lg-7">
              <div className="col-lg-12">
                <div>
                  <h5
                    className="mainClass"
                    style={{ color: "rgba(173, 77, 255, 1)" }}
                  >
                    <b>Recharge Your Wallet</b>
                  </h5>
                  <p className="mt-3">
                    Payment for all services is exclusively conducted through
                    pujaguru wallet.
                  </p>
                  <p className="mt-3">
                    You have the flexibility to recharge your wallet with any
                    desired amount.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 images">
              <div className="image1">
                <img className="img-fluid" src={image3} alt="" />
              </div>
            </div>
          </div>

          <div
            style={{ backgroundColor: "rgba(240, 245, 255, 1)" }}
            className="row mt-2 align-items-center flex-wrap-reverse"
          >
            <div className="col-lg-5 images">
              <div className="image1">
                <img className="img-fluid" src={image4} alt="" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="col-lg-12">
                <div className="p-3">
                  <h5
                    className="mainClass"
                    style={{ color: "rgba(173, 77, 255, 1)" }}
                  >
                    <b>Booking Talk/Chat Service</b>
                  </h5>
                  <p className="mt-3">
                    For users opting for talk or chat services with a
                    specialist, it's essential to recharge your wallet with the
                    minimum required amount, equivalent to at least 5 minutes of
                    talk/chat time.
                  </p>
                  <p className="mt-3">
                    after recharging your wallet, complete the booking form and
                    commence your conversation.
                  </p>
                  <p className="mt-3">
                    If you have existing balance in your wallet, just fill out
                    the form and initiate the conversation.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row d-flex align-items-center mt-3">
            <div className="col-lg-7">
              <div className="col-lg-12">
                <div>
                  <h5
                    className="mainClass"
                    style={{ color: "rgba(173, 77, 255, 1)" }}
                  >
                    <b>Booking Reports </b>
                  </h5>
                  <p className="mt-3">
                    Select the desired report for yourself, then choose the
                    specialist offering that service.
                  </p>
                  <p className="mt-3">
                    Subsequently, complete the form, make payment using your
                    wallet funds, and await the specialist to generate your
                    report
                  </p>
                  <p className="mt-3">
                    Please note that it may take up to 48 hours to compile your
                    report based on the information provided in the booking
                    form.
                  </p>
                  <p className="mt-3">
                    Once the specialist uploads your report, you can access it
                    in the report section of your account upon logging in.
                  </p>
                  <p className="mt-3">
                    You have access to a complimentary chat feature for
                    communicating with the specialist regarding the booked
                    service
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 images">
              <div className="image1">
                <img className="img-fluid" src={image5} alt="" />
              </div>
            </div>
          </div>

          <div
            style={{ backgroundColor: "rgba(240, 245, 255, 1)" }}
            className="row mt-2 align-items-center flex-wrap-reverse"
          >
            <div className="col-lg-5 images">
              <div className="image1">
                <img className="img-fluid" src={image6} alt="" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="col-lg-12">
                <div className="p-3">
                  <h5
                    className="mainClass"
                    style={{ color: "rgba(173, 77, 255, 1)" }}
                  >
                    <b>Booking Online Puja</b>
                  </h5>
                  <p className="mt-3">
                    Choose the desired puja you wish to have performed and then
                    select the specialist providing this service.
                  </p>
                  <p className="mt-3">
                    Proceed by filling out the booking form, make payment using
                    your wallet funds, and wait for the specialist to provide
                    you with an auspicious muhurat.
                  </p>
                  <p className="mt-3">
                    Once confirmed, the specialist will send you a link to join
                    the puja 24 hours prior to the scheduled muhurat.
                  </p>
                  <p className="mt-3">
                    In case you are unable to join the virtual for any reason,
                    you can watch the puja video later when the specialist
                    uploads it after completing the puja.
                  </p>
                  <p className="mt-3">
                    You have access to a complimentary chat feature for
                    communicating with the specialist regarding the booked
                    service.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row d-flex align-items-center mt-3">
            <div className="col-lg-7">
              <div className="col-lg-12">
                <div>
                  <h5
                    className="mainClass"
                    style={{ color: "rgba(173, 77, 255, 1)" }}
                  >
                    <b>Booking In-Person Puja </b>
                  </h5>
                  <p className="mt-3">
                    Choose the desired puja you wish to have performed and then
                    select the specialist providing that service.
                  </p>
                  <p className="mt-3">
                    Proceed by filling out the booking form, make payment using
                    your wallet funds, and wait for the specialist to provide
                    you with an auspicious muhurat.
                  </p>
                  <p className="mt-3">
                    Once confirmed, the specialist will visit your location to
                    conduct the puja.
                  </p>
                  <p className="mt-3">
                    You have access to a complimentary chat feature for
                    communicating with the specialist regarding the booked
                    service.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-5 images">
              <div className="image1">
                <img className="img-fluid" src={image7} alt="" />
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </div>
  );
}


